import { createSlice } from "@reduxjs/toolkit";

const clubSlice = createSlice({
    name:'club',
    initialState:{
        club:[]
    },
    reducers: {
        addClub : (state,action) => {
            // console.log("test ",action)
            //state.push(action.payload)
            state.club = [...state.club,action.payload]
        },
        // removeOccupation(){
        //     return state.occupation.filter((item)=> item.id != action.payload);
        // }
    }
});

export const { addClub } = clubSlice.actions;
export default clubSlice.reducer;